import { sanitizeNamePrefill } from "./profileName";

const ACCOUNT_STORAGE_KEY = "nightStayAccount";
const SESSION_STORAGE_KEY = "nightStaySession";
const AUTH_EVENT = "nightStayAuthChange";

export const DEFAULT_ACCOUNT = {
  name: "",
  email: "",
  password: "",
};

const canUseStorage = () =>
  typeof window !== "undefined" && typeof window.localStorage !== "undefined";

const safeParse = (value) => {
  if (!value) return null;
  try {
    return JSON.parse(value);
  } catch (error) {
    console.warn("Failed to parse stored night stay auth data", error);
    return null;
  }
};

const emitAuthChange = () => {
  if (typeof window === "undefined") return;
  window.dispatchEvent(new Event(AUTH_EVENT));
};

export const getStoredAccount = () => {
  if (!canUseStorage()) return null;
  const raw = window.localStorage.getItem(ACCOUNT_STORAGE_KEY);
  const parsed = safeParse(raw);
  if (!parsed || !parsed.email || !parsed.password) return null;
  return parsed;
};

export const saveAccount = (account) => {
  if (!canUseStorage()) return;
  window.localStorage.setItem(ACCOUNT_STORAGE_KEY, JSON.stringify(account));
  emitAuthChange();
};

export const clearAccount = () => {
  if (!canUseStorage()) return;
  window.localStorage.removeItem(ACCOUNT_STORAGE_KEY);
  emitAuthChange();
};

export const getActiveSession = () => {
  if (!canUseStorage()) return null;
  const raw = window.localStorage.getItem(SESSION_STORAGE_KEY);
  const parsed = safeParse(raw);
  const hasIdentity = parsed && (parsed.email || parsed.phone);
  if (!parsed || !hasIdentity) return null;
  return { ...parsed, name: sanitizeNamePrefill(parsed.name) };
};

export const saveSession = (session) => {
  if (!canUseStorage()) return;
  window.localStorage.setItem(SESSION_STORAGE_KEY, JSON.stringify({ ...session, name: sanitizeNamePrefill(session?.name) }));
  emitAuthChange();
};

export const clearSession = () => {
  if (!canUseStorage()) return;
  window.localStorage.removeItem(SESSION_STORAGE_KEY);
  emitAuthChange();
};

export { ACCOUNT_STORAGE_KEY, SESSION_STORAGE_KEY, AUTH_EVENT };
